import { Column } from "@/components/Column";
import { CopyButton } from "@/components/CopyButton";
import { Row } from "@/components/Row";
import { Text } from "@/components/Text";

import { sadieSessionKindToLabel } from "@/lib/constants";
import { SadieSimulatorSession } from "@/types";

// The sessions since the last start over. Langfuse finds a session's turns by
// its id.
export const SadieSimulatorSessions = ({
  sessions,
}: {
  sessions: SadieSimulatorSession[];
}) => (
  <Column className="gap-2">
    <Text className="text-sm font-medium text-slate-700">Sessions</Text>
    {sessions.map((session) => (
      <Row className="items-center justify-between gap-2" key={session.id}>
        <Column className="min-w-0 gap-0">
          <Text className="text-xs text-slate-700">
            {`${sadieSessionKindToLabel[session.kind] || session.kind}, ${session.status.toLowerCase()}`}
          </Text>
          <Text className="truncate font-mono text-xs font-normal text-slate-500">
            {session.id}
          </Text>
        </Column>
        <CopyButton toCopy={session.id} />
      </Row>
    ))}
  </Column>
);
